import FileSaver from "file-saver";

export const utilities = {
  formatPhoneNumber,
  getMonthName,
  convertTo24H,
  handlePDFDownload,
  handlePDFOpen,
  normalizeAddressComponents
};

function handlePDFDownload(baseString, newFileName) {
  let sliceSize = 1024;
  let byteCharacters = atob(baseString);
  let bytesLength = byteCharacters.length;
  let slicesCount = Math.ceil(bytesLength / sliceSize);
  let byteArrays = new Array(slicesCount);
  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    let begin = sliceIndex * sliceSize;
    let end = Math.min(begin + sliceSize, bytesLength);
    let bytes = new Array(end - begin);
    for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  FileSaver.saveAs(
    new Blob(byteArrays, { type: "application/pdf;charset=utf-8" }),
    newFileName
  );
}

function handlePDFOpen(baseString) {
  try {
    let pdfData = `data:application/pdf;base64,${baseString}`;
    let newW = window.open("");

    if (newW) {
      newW.document.write(
        `<embed width="100%" height="100%" src="${pdfData}" type="application/pdf" />`
      );
    } else {
      throw new Error("Failed to open a new tab.");
    }
  } catch (error) {
    console.error("Error opening PDF in new tab:", error);
  }
}

function formatPhoneNumber(phone) {
  if (phone === null || phone === undefined) {
    return "";
  } else {
    phone = phone.replace(/\D/g, "");
    if (phone.length < 10) {
      return "";
    } else {
      const match = phone.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
      if (match) {
        phone = `(${match[1]}${match[2] ? ") " : ""}${match[2]}${
          match[3] ? "-" : ""
        }${match[3]}${match[4] ? " x" : ""}${match[4]}`;
      }
      return phone;
    }
  }
}

function getMonthName(objDate) {
  var locale = "en-us",
    month = objDate.toLocaleString(locale, { month: "long" });

  return month;
}

function convertTo24H(time) {
  var hours = Number(time.match(/^(\d+)/)[1]);
  var minutes = Number(time.match(/:(\d+)/)[1]);
  var AMPM = time.match(/\s(.*)$/)[1];
  if (AMPM == "PM" && hours < 12) hours = hours + 12;
  if (AMPM == "AM" && hours == 12) hours = hours - 12;
  var sHours = hours.toString();
  var sMinutes = minutes.toString();
  if (hours < 10) sHours = "0" + sHours;
  if (minutes < 10) sMinutes = "0" + sMinutes;
  return sHours + ":" + sMinutes + ":00";
}

function normalizeAddressComponents(components = []) {
    return components.map((c) => ({
      long_name: c.Eg || c.nh,   
      short_name: c.Fg || c.oh,  
      types: c.Dg ||c.mh ||[],
    }));
}